/**
 * Public Endpoints
 */
import { getApiClient } from "../client";
import { MaintenanceStatusSchema } from "../schemas";
import { parseStrapiItemResponse } from "../utils/parseStrapiResponse";
/**
 * Public endpoints (no authentication required)
 * Note: These endpoints use omitMiddlewares: ["global::parse-data"] so they return data directly
 */
export const publicEndpoints = {
    /**
     * Get maintenance status
     */
    async getMaintenanceStatus() {
        const response = await getApiClient().get("/public/app-in-maintenance");
        return parseStrapiItemResponse(response.data, {
            schema: MaintenanceStatusSchema,
            context: "publicEndpoints.getMaintenanceStatus",
        });
    },
    /**
     * Get news/public info
     * Returns a wrapper object containing news array and updatedAt timestamp
     * Note: This endpoint returns data directly (no parse-data middleware)
     */
    async getNews() {
        const response = await getApiClient().get("/public");
        // No schema - custom response type
        return parseStrapiItemResponse(response.data);
    },
    /**
     * Get currency pairs (from Revolut)
     * Returns a map of currency pair symbols to their rate info
     * Note: This endpoint returns data directly (no parse-data middleware)
     */
    async getCurrencyPairs() {
        const response = await getApiClient().get("/revolut/currency-pairs");
        // No schema - dynamic response type
        return parseStrapiItemResponse(response.data);
    },
};
